(() => {
  const globalKey = 'CyantInnerAnnouncementInitialized';
  if (window[globalKey]) {
    window[globalKey].init(document);
    return;
  }

  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const records = new Map();

  const reset = (record) => {
    record.resizeObserver?.disconnect();
    if (record.frame !== null) window.cancelAnimationFrame(record.frame);
    if (record.schedule) {
      window.removeEventListener('scroll', record.schedule);
      window.removeEventListener('resize', record.schedule);
    }
    record.announcement = null;
    record.resizeObserver = null;
    record.frame = null;
    record.schedule = null;
    record.section.classList.remove('cyant-announcement-active');
    record.section.style.removeProperty('--cy-announcement-height');
    record.section.style.removeProperty('--cy-announcement-progress');
  };

  const sync = (record) => {
    if (!desktopMedia.matches || !record.announcement) return;
    const bounds = record.announcement.getBoundingClientRect();
    const height = bounds.height;
    // Fade the shared height + gap distance to zero as the bar leaves the viewport.
    const progress = height > 0 ? Math.min(1, Math.max(0, bounds.bottom / height)) : 0;
    record.section.style.setProperty('--cy-announcement-height', `${height}px`);
    record.section.style.setProperty('--cy-announcement-progress', `${progress}`);
    record.section.classList.toggle('cyant-announcement-active', height > 0);
  };

  const configure = (record) => {
    reset(record);
    if (!desktopMedia.matches) return;

    let announcement = record.section.previousElementSibling;
    while (announcement && !announcement.matches('.announcement-bar-section')) {
      announcement = announcement.previousElementSibling;
    }
    if (!announcement?.querySelector('.announcement-bar__message')) return;

    record.announcement = announcement;
    record.schedule = () => {
      if (record.frame !== null) return;
      record.frame = window.requestAnimationFrame(() => {
        record.frame = null;
        sync(record);
      });
    };
    sync(record);
    if ('ResizeObserver' in window) {
      record.resizeObserver = new ResizeObserver(record.schedule);
      record.resizeObserver.observe(announcement);
    }
    window.addEventListener('scroll', record.schedule, { passive: true });
    window.addEventListener('resize', record.schedule, { passive: true });
  };

  const initSection = (section) => {
    if (!section.querySelector('.cyant-header--inner')) return;
    const previous = records.get(section);
    if (previous) reset(previous);
    const record = { section, announcement: null, resizeObserver: null, frame: null, schedule: null };
    records.set(section, record);
    configure(record);
  };

  const init = (root = document) => {
    if (root instanceof Element && root.matches('.section-header')) initSection(root);
    root.querySelectorAll?.('.section-header').forEach(initSection);
  };
  const reconfigure = () => records.forEach(configure);

  if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', reconfigure);
  else desktopMedia.addListener(reconfigure);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    if (event.target.matches('.announcement-bar-section')) reconfigure();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    records.forEach((record, section) => {
      if (section === event.target || event.target.contains(section)) {
        reset(record);
        records.delete(section);
      } else if (record.announcement && event.target.contains(record.announcement)) {
        reset(record);
      }
    });
  });
  document.addEventListener('shopify:section:reorder', reconfigure);

  window[globalKey] = { init };
  init(document);
})();
